<script setup>
import { computed } from 'vue';
import { useNotifier } from '/app/composables/notifier';
import { toHTML } from '/app/composables/markdown';
import NNotify from '/app/components/NNotify.vue';

const { title, message, opened, close, onConfirm, onCancel, payload, confirmText, cancelText, hideCancel, hideConfirm, hideOverlay, type } = useNotifier();

const isRenderFn = computed(() => typeof message.value === 'function');

const MessageRenderer = computed(() => {
    if (!isRenderFn.value) return null;
    const fn = message.value;
    return { render: () => fn({ payload: payload.value }) };
});

const html = computed(() =>
    isRenderFn.value || message.value == null
        ? ''
        : toHTML(message.value, { inline: true })
);
</script>

<template>
    <NNotify
        v-model="opened"
        :title="title"
        :cancel-text="cancelText"
        :confirm-text="confirmText"
        :hide-cancel="hideCancel"
        :hide-confirm="hideConfirm"
        :hide-overlay="hideOverlay"
        :type="type"
        :handle-confirm="() => onConfirm({ payload })"
        :handle-cancel="() => onCancel({ payload })"
        @close="close"
    >
        <template #content>
            <div class="w-80">
                <component :is="MessageRenderer" v-if="isRenderFn" />
                <div v-else v-html="html" />
            </div>
        </template>
    </NNotify>
</template>
